var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { cloneElement, forwardRef } from 'react';
import { useEvent } from '@anton.bobrov/react-hooks';
export var Anchor = forwardRef(function (_a, forwardedRef) {
    var activate = _a.activate, deactivate = _a.deactivate, isActive = _a.isActive, showEvent = _a.showEvent, anchor = _a.anchor;
    var toggle = useEvent(function () {
        if (isActive) {
            deactivate();
        }
        else {
            activate();
        }
    });
    if (!anchor) {
        return null;
    }
    var props = showEvent === 'click'
        ? {
            onClick: function (event) {
                var _a, _b;
                (_b = (_a = anchor.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, event);
                toggle();
            },
        }
        : {
            onMouseEnter: function (event) {
                var _a, _b;
                (_b = (_a = anchor.props).onMouseEnter) === null || _b === void 0 ? void 0 : _b.call(_a, event);
                activate();
            },
            onMouseLeave: function (event) {
                var _a, _b;
                (_b = (_a = anchor.props).onMouseLeave) === null || _b === void 0 ? void 0 : _b.call(_a, event);
                deactivate();
            },
            onFocus: function (event) {
                var _a, _b;
                (_b = (_a = anchor.props).onFocus) === null || _b === void 0 ? void 0 : _b.call(_a, event);
                activate();
            },
            onBlur: function (event) {
                var _a, _b;
                (_b = (_a = anchor.props).onBlur) === null || _b === void 0 ? void 0 : _b.call(_a, event);
                deactivate();
            },
        };
    return cloneElement(anchor, __assign({ ref: forwardedRef }, props));
});
Anchor.displayName = 'Anchor';
//# sourceMappingURL=index.js.map